const dispatchCustomEvent = (dispatcher, eventName, detail = {}) => {
	const event = new CustomEvent(eventName, {
		bubbles: true,
		detail,
	});

	dispatcher.dispatchEvent(event);
};

export default dispatchCustomEvent;
